//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.StructureDesign.js";
import "../no/Builder.js";
import "../no/SelectTaggedObjectList.js";
import "../no/SelectObjectList.js";
let d=[[[0,"Catalog",1,0],[0,"Description",1,0],[0,"DesignName",1,0],[0,"FileName",1,0],[1,"Reference",0,"SelectTaggedObjectList",0],[0,"ReferenceOrientation",1,"Direction",0],[0,"StructreRootNode",1,"ShipDesign.NavigatorNode",0],[0,"UpOrientation",1,"Direction",0]],[[[],"CreateStructure",{R_:{structure:"Part"}},0,0]],[]];
SPLM.Features.StructureDesign.CreateStructureBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.StructureDesign.CreateStructureBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.StructureDesign.CreateStructureBuilder.PartTypes = Object.freeze({
    "Structure" : "Structure", "Design" : "Design"});

export default SPLM;